import { getYoutubeVideos } from "@repository/youtubeVideosRepository";
import { useQuery } from "react-query";

const useFetchEvents = (lang: string) => {
  const { data, isLoading, isError } = useQuery(
    ["youtubeVideos"],
    () => getYoutubeVideos(lang),
    {
      refetchInterval: 1000 * 60 * 60,
    }
  );
  return { youtubeVideos: data, isLoading, isError };
};

export default useFetchEvents;
